import { render, staticRenderFns } from "./CreatedOrEditedDriver.vue?vue&type=template&id=5d76b552&scoped=true&"
import script from "./CreatedOrEditedDriver.vue?vue&type=script&lang=js&"
export * from "./CreatedOrEditedDriver.vue?vue&type=script&lang=js&"
import style0 from "./CreatedOrEditedDriver.vue?vue&type=style&index=0&id=5d76b552&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d76b552",
  null
  
)

export default component.exports